'use strict';

import template from './overflow.html';
import angular from 'angular';

import './overflow.css';

const saOverflow = ($timeout) => {
  'ngInject';

  return {
    template: template,
    scope: {
      text: '=',
      revealText: '@',
      retainWhitespace: '@',
    },
    link: function ($scope, $element) {
      // Kisunas SEO workaround
      //if (window.location.pathname === "/guides/ukraine/kiev") {
      //  $scope.textExpanded = true;
      //}
      if ($scope.retainWhitespace != '1') {
        $scope.text = $scope.text.replace(/\n\s*\n/g, '\n');
      }
      if (!$scope.revealText) {
        $scope.revealText = 'More';
      }
      $timeout(() => {
        $element = angular.element($element[0].children[0]);
        var textElement = $element[0].children[0];
        const BUFFER = 4;
        if (textElement.scrollHeight > ($element[0].scrollHeight + BUFFER)) {
          $element.addClass('Overflow');
        }
      });

      $scope.expand = () => {
        $scope.textExpanded = true;
      };
    },
    // Why won't this work?
    // bindToController: true,
    // controllerAs: '$ctrl',
    // controller: function ($scope) {
    //   'ngInject';
    //   $scope.expand = () => {
    //     console.log($scope.text)
    //     console.log($scope.originalText)
    //     $scope.text = $scope.originalText;
    //     $scope.textExpanded = true;
    //   };
    // },
  };
};

export default angular
  .module('common.overflow', [])
  .directive('saOverflow', saOverflow)
  .name;



// WEBPACK FOOTER //
// ./app/src/modules/overflow/overflow.js